// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clockTriangle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clock-triangle': IconClockTriangle;
    }
}

/**
 * The icon component for the 'clockTriangle' icon
 */
export class IconClockTriangle extends IconSvg {
    public constructor() {
        super(clockTriangle16X16);
    }
}

registerIconSvg('icon-clock-triangle', IconClockTriangle);
export const iconClockTriangleTag = 'nimble-icon-clock-triangle';
